import * as React from 'react'

export const BoldIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M11.1695 2.74982C13.7586 2.74982 15.7004 3.07454 16.995 3.83223C18.3975 4.58991 19.0447 5.8888 19.0447 7.7289C19.0447 8.81131 18.7211 9.78548 18.2896 10.5432C18.045 10.9133 17.7273 11.2291 17.3562 11.4711C16.985 11.7132 16.5684 11.8762 16.132 11.9503C16.7487 12.0948 17.3337 12.3516 17.8581 12.708C18.2896 13.0327 18.7211 13.5739 19.0447 14.1151C19.3824 14.8992 19.5302 15.7523 19.4763 16.6047C19.5144 17.3866 19.3682 18.1666 19.0496 18.8813C18.7309 19.596 18.2488 20.2252 17.6423 20.7178C16.1066 21.8183 14.2395 22.3535 12.3561 22.2332H5.12814V2.74982H11.1695ZM11.601 10.4349C12.7877 10.4349 13.6507 10.3267 14.0822 9.89372C14.6216 9.56899 14.8374 8.91955 14.8374 8.2701C14.8374 7.51242 14.5138 6.97121 13.9744 6.64649C13.435 6.32177 12.5719 6.10529 11.3852 6.10529H9.22761V10.4349H11.601ZM9.22761 13.6822V18.986H11.9246C13.1113 18.986 14.0822 18.6612 14.5138 18.2283C15.0532 17.6871 15.2689 17.1459 15.2689 16.2799C15.2818 15.9528 15.2205 15.6269 15.0897 15.3269C14.9589 15.027 14.762 14.7607 14.5138 14.5481C13.9744 14.1151 13.1113 13.8986 11.8167 13.8986H9.11973L9.22761 13.6822Z'
        fill='currentColor'
      />
    </svg>
  )
})

BoldIcon.displayName = 'BoldIcon'
